import styled from 'styled-components';
import Popover from 'react-popover';

import {
  Button,
} from 'web-components';

import {
  Flex,
  icons,
} from 'web-styled';

export const StyledPopover = styled(Popover)`
  z-index: 9999;
  & > .Popover-tip {
    fill: ${props => props.tipColor || 'white'};
  }
`;

export const BodyContainer = styled(Flex).attrs({
  fillSpace: true,
})`
  background: #fff;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Trigger = styled(Button).attrs({
  appearance: 'empty',
})`
  border: none;
  background: transparent url(${icons.chevronDownGrey}) no-repeat;
  background-size: contain;
  background-color: transparent;
  transform: rotate(${props => (props.isOpen ? 180 : 0)}deg);
  box-shadow: none;
  height: 25px;
  width: 25px;
`;
